import React from 'react';
import { Link } from 'react-router-dom';
import { processSteps, clientAvatars } from '../mock';
import { ArrowUpRight, Star } from 'lucide-react';

const Process = () => {
  return (
    <section className="relative py-20 md:py-28 bg-paper-soft">
      <div className="squiggle-bg" />
      <div className="max-w-6xl mx-auto px-6 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#143324]/20 bg-[#ece7db] text-[11px] tracking-[0.2em] uppercase text-[#143324] font-body mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#143324]" />
              How It Works
            </div>
            <h2 className="font-serif-display text-[#143324] text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              A Proven Path to <em className="italic">Certification</em>
            </h2>
            <p className="mt-5 text-[#3d3d3d] text-[15px] leading-relaxed max-w-md font-body">
              Our step-by-step approach simplifies the SEE exams, delivers real-world tax practice, and places you in top firms.
            </p>
            <div className="mt-8 flex items-center gap-3 flex-wrap">
              <Link to="/contact" className="inline-flex items-center gap-2 btn-primary px-6 py-3 rounded-full text-sm font-body">
                Enroll Now <ArrowUpRight size={16} />
              </Link>
              <Link to="/ea-course" className="inline-flex items-center gap-2 btn-outline px-6 py-3 rounded-full text-sm font-body">
                Explore Course
              </Link>
            </div>

            <div className="mt-10 flex items-center gap-4">
              <div className="flex -space-x-3">
                {clientAvatars.slice(0, 4).map((a, i) => (
                  <img key={i} src={a} alt="student" className="w-10 h-10 rounded-full border-2 border-[#f2eee4] object-cover" />
                ))}
              </div>
              <div>
                <div className="flex items-center gap-0.5 mb-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={12} className="star-filled" fill="currentColor" />
                  ))}
                  <span className="text-xs text-[#3d3d3d] ml-1 font-body">Rated by 2,488+ students</span>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            {processSteps.map((step, i) => (
              <div key={i} className="card-soft rounded-2xl p-6 md:p-7 flex gap-5 items-start hover:shadow-md transition-shadow duration-300">
                <div className="font-serif-display text-[#143324] text-5xl md:text-6xl leading-none italic min-w-[60px]">
                  {step.number}
                </div>
                <div>
                  <h3 className="font-body font-semibold text-[#143324] text-lg md:text-xl mb-2">{step.title}</h3>
                  <p className="text-[#3d3d3d] text-[14px] leading-relaxed font-body">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
